import { Model } from '@/models/Model';
export class Tag extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Tag';
        this.$endpoint = '/tags';
        this.$fillable = ['name'];
    }
}
